import { useRef } from "react";
import { Box, Text, Icon } from "@quintoandar-tokko/jopijs";
import { useDispatch, useSelector } from "react-redux";
import Map from "../../map/Map";
import style from "../fichaInfo.module.scss";
import translations from "../FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";
import WrapperEdition from "../wrapperEdition/WrapperEdition";
import { setToogleEditionValue } from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import Skeletons from "../skelenton/Skeleton";
import { handleLinkClick } from "../utilities/helpers";

export default function Location() {
  const dispatch = useDispatch();
  const state = useSelector((ste) => ste.FichaInfoSlice);
  const { isEdition, showData, edited_data, origin_data, loading } = state;
  const refContainer = useRef(null);
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${origin_data.geolocation.lat},${origin_data.geolocation.lng}`;
  const visibilityMap = showData === "origin_data" || edited_data.show_location;

  if (loading)
    return (
      <Box __css={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Skeletons width={150} borderRadius={50} />
        <Skeletons width="100%" borderRadius={16} height="100%" />
      </Box>
    );

  return (
    <WrapperEdition
      eye={false}
      title={Trans(translations, "ViewMap")}
      handleShow={() => dispatch(setToogleEditionValue("show_location"))}
      enabled={edited_data.show_location}
      typeOfData="location-map"
    >
      <Box
        data-testid="location-map"
        className={style.locationCont}
        ref={refContainer}
      >
        {!isEdition && visibilityMap && (
          <Box __css={{ display: "flex", justifyContent: "space-between" }}>
            <Text className={style.BITitle} variant="bodyBold.fontSize14">
              {Trans(translations, "Location")}
            </Text>
            <Box
              marginBottom="16px"
              className={style.redirectGoogleMaps}
              onClick={() => handleLinkClick(googleMapsUrl)}
            >
              <Text variant="bodyBold.fontSize14">
                {Trans(translations, "OpenInGoogleMaps")}
              </Text>
              <Icon icon="icon-ir" fontSize="16px" />
            </Box>
          </Box>
        )}
        {visibilityMap && (
          <Map
            lat={Number(origin_data.geolocation.lat)}
            lng={Number(origin_data.geolocation.lng)}
          />
        )}
      </Box>
    </WrapperEdition>
  );
}
